import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { adminApiUrl, getUserCredentials } from "../../axiosUtils";

type MonthlyReportParams = {
    startTime:  string
    endTime:    string
}

export type MonthlyReportRow = {
    id:         string

    cost:       number
    gimProfit:  number

    firstName: string
    lastName: string

    startTime: string
    endTime: string
    duration: string

    state: string
}

export const getMonthlyReport = ({ startTime, endTime }: MonthlyReportParams) => {
    return new Promise((resolve: (value: { rows: MonthlyReportRow[] }) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
                params: { startTime, endTime }
            };

            axios.get(`${adminApiUrl}/v1/transactions/history/monthly-report`, config)
            .then((res) => { 
                resolve(res.data)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/transactions/history/monthly-report`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 
